import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'dialog-credits',
    templateUrl: 'dialog-credits.component.html',
    styleUrls: ['dialog-credits.component.scss']
})
export class DialogCredits implements OnInit {
    
    constructor(
        public dialogRef: MatDialogRef<DialogCredits>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        console.log(this.data)
    }
    dismissDialog(){
        this.dialogRef.close();
    }
}